define(['text!./templates/basler-error-ctrl-group.html',
    './util/BaslerUtil',
], (templateStr, BaslerUtil) => {

    let inputId = 0;

    const directiveFunc = function () {
        return {

            require: ['^form'],
            transclude: true,
            scope: {
                readonly: '=?',
                model: '=',
            },
            replace: true,
            template: templateStr,

            controller: ['$scope', function ($scope) {

                $scope.pristine = true;
                //once a different value is set on the model then we mark the field as not pristine
                $scope.$watch('model.value', (newValue, oldValue) => {
                    $scope.pristine = (!$scope.pristine) ? false : newValue === oldValue;
                });
            }],

            link: function (scope, element, attrs, ctrls) {

                scope.mouseEnterAdding = BaslerUtil.mouseEnterAdding;

                scope.mouseLeaveAdding = BaslerUtil.mouseLeaveAdding;

                const parentForm = ctrls[0];
                const validityFn = function () {
                    return scope.model.aspects.valid;
                };
                const setPristineFn = function () {
                    //we need to use this postDigest function here because the
                    //watch on 'model.value' in the controller gets called after
                    //this function is called even though the model was changed first
                    scope.$$postDigest(
                        () => {
                            scope.pristine = true;
                        }
                    );
                };

                if (parentForm) {
                    const removeListenerFn = parentForm.addModelControl(validityFn, setPristineFn);
                    scope.$on('$destroy', removeListenerFn);
                }


                if (!('readonly' in scope) && attrs.readonly === '') {
                    //if readonly attr exists with no value then set it to true
                    scope.readonly = true;
                }
                scope.isVisible = function () {
                    return !('visible' in scope.model.aspects) || scope.model.aspects.visible;
                };

                scope.inputId = inputId++;

                scope.showError = function () {
                    const formHasBeenSubmitted = !parentForm || parentForm.submitted;
                    return !scope.model.aspects.valid && formHasBeenSubmitted;
                };

                scope.getValidationMessages = function () {
                    const messages = [];

                    if (scope.model.aspects.validationMessages.length > 0) {
                        messages.push(scope.model.aspects.validationMessages[0]);
                    }

                    return messages;
                };

                element.on('focusin', () => {
                    scope.focused = true;
                    scope.$applyAsync(); //to fix issue "$apply already in progress" http://stackoverflow.com/questions/18626039/apply-already-in-progress-error
                });
                element.on('focusout', () => {
                    scope.focused = false;
                    scope.$applyAsync(); //to fix issue "$apply already in progress" http://stackoverflow.com/questions/18626039/apply-already-in-progress-error
                });
            },
        };
    };

    return directiveFunc;
});




// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerErrorCtrlGroupDirective.js